import {
  createWebhook,
  deleteWebhook,
  editWebhook,
  editWebhookStatus,
  fetchWebhookActivities,
  fetchWebhookById,
  fetchWebhooks,
  testWebhook,
} from '../routines/webhookRoutines';

const initialState = {
  isLoading: false,
  isSaving: false,
  isTesting: false,
  isTestingError: false,
  isTestingSuccess: false,
  selectedWebhook: {
    isLoading: false,
  },
  selectedWebhookActivities: {
    activities: [],
    paginationData: {},
    isLoading: false,
  },
  webhookList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch (all / by ID) / edit status / delete TRIGGER webhook
    case fetchWebhooks.TRIGGER:
    case editWebhookStatus.TRIGGER:
    case deleteWebhook.TRIGGER:
      return { ...state, isLoading: true };
    case fetchWebhookById.TRIGGER: {
      return {
        ...state,
        selectedWebhook: {
          isLoading: true,
        },
      };
    }

    // fetch (all / by ID) / edit status / delete SUCCESS webhook
    case fetchWebhooks.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        webhookList: action.payload || [],
      };
    }
    case fetchWebhookById.SUCCESS: {
      return {
        ...state,
        selectedWebhook: {
          isLoading: false,
          ...action.payload,
        },
      };
    }
    case editWebhookStatus.SUCCESS:
    case deleteWebhook.SUCCESS:
      return { ...state, isLoading: false };

    // fetch (all / by ID) / edit status / delete FAILURE webhook
    case fetchWebhooks.FAILURE:
    case deleteWebhook.FAILURE:
    case editWebhookStatus.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case fetchWebhookById.FAILURE:
      return {
        ...state,
        selectedWebhook: {
          ...state.selectedWebhook,
          isLoading: false,
        },
      };

    // create / edit webhook
    case createWebhook.TRIGGER:
    case editWebhook.TRIGGER:
      return { ...state, isSaving: true };
    case createWebhook.SUCCESS:
    case editWebhook.SUCCESS:
      return { ...state, isSaving: false };
    case createWebhook.FAILURE:
    case editWebhook.FAILURE:
      return { ...state, isSaving: false };

    // fetch webhook activities
    case fetchWebhookActivities.TRIGGER:
      return {
        ...state,
        selectedWebhookActivities: {
          activities: [],
          isLoading: true,
        },
      };
    case fetchWebhookActivities.SUCCESS:
      return {
        ...state,
        selectedWebhookActivities: {
          activities: action.payload.data,
          paginationData: {
            page: action.payload.page,
            pageSize: action.payload.pageSize,
            totalItems: action.payload.totalItemCount,
          },
          isLoading: false,
        },
      };
    case fetchWebhookActivities.FAILURE:
      return {
        ...state,
        selectedWebhookActivities: {
          activities: [],
          paginationData: {},
          isLoading: false,
        },
      };

    // test webhook
    case testWebhook.TRIGGER:
      return { ...state, isTesting: true };
    case testWebhook.SUCCESS: {
      return {
        ...state,
        isTesting: false,
        isTestingError: false,
        isTestingSuccess: true,
      };
    }
    case testWebhook.FAILURE:
      return {
        ...state,
        isTesting: false,
        isTestingError: true,
        isTestingSuccess: false,
      };
    default:
      return state;
  }
};
